<div class="p-10 m-20"  >      
  <form [formGroup]="programForm">
    <ion-row class="center-content">
      <ion-col size-sm="3" size-md="9" size-lg="2" size-xs="10" class="mb-10">
        <div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <mat-select placeholder="Select" formControlName="selectedProgram">
              <mat-option *ngFor="let program of programList" [value]="program">
                {{ program }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </ion-col>         
    </ion-row>
  </form> 
<div class="table-container">
  <table class="custom-table rounded-header">
     <thead>
      <tr>
        <ng-container *ngFor="let item of tableHeaders">
          <th *ngIf="item.label !== 'Action'" class="fs-14 font_bold cl-black">
            <div class="verticle-center justify-content-space-between icon-style">
              {{ item?.label }}
            </div>
          </th>
        </ng-container>
      </tr>
    </thead>
      <tbody class="bg-white">
        <tr *ngFor="let program of trainingPrograms">
         <td>{{ program.trainingType }}</td>
          <td>{{ program.title }}</td>
          <td>{{ program.code }}</td>
          <td><a [href]="program.lmsLink" target="_blank">link</a></td>
          <td>{{ program.startDate }}</td>
          <td>{{ program.endDate }}</td>
          <td>{{ program.category }}</td>
          <td>{{ program.department }}</td>
          <td>{{ program.band }}</td>
          <td>{{ program.grade }}</td>
          <td>{{ program.location }}</td>
          <td>{{ program.programDays }}</td>
          <td>{{ program.budgetCost }}</td>
          <td>{{ program.actualCost }}</td>
          <td>{{ program.objective }}</td>
        </tr>
      </tbody>
  </table>
</div>


<!-- Employee approve/reject -->

<div class="mt-10" style="font-weight: bold; margin-top: 45px !important;">
<div class="table-container">
  <table class="custom-table rounded-header">
    <thead>
      <tr>
        <th *ngFor="let item of employeeTableHeaders" class="fs-14 font_bold cl-black">
          <div class="verticle-center justify-content-space-between icon-style">
            {{ item?.label }}
          </div>
        </th>
      </tr>
    </thead>

    <tbody class="bg-white">
      <tr *ngFor="let program of employeeTrainingPrograms">
        <td>{{ program.code }}</td>
        <td>{{ program.name }}</td>
        <td>{{ program.department }}</td>
        <td>{{ program.band }}</td>
        <td>{{ program.grade }}</td>
        <td>
          <mat-radio-group [(ngModel)]="program.status" aria-label="Select Status" class="fs-14 font_semibold">
            <mat-radio-button value="Approved" class="approve-radio">
              Approve
            </mat-radio-button>
            <mat-radio-button value="Rejected" class="reject-radio pl-10">
              Reject
            </mat-radio-button>
          </mat-radio-group>
        </td>
      </tr>
    </tbody>
  </table>
</div>

</div>
</div>
